/**
 * The pickers' own cache. Lists refetch every time a picker opens (`staleTime: 0` in the picker),
 * so nothing here needs invalidating from the features that change products or collections.
 */
export const resourcePickerKeys = {
  all: ['resource-pickers'] as const,
  products: (params: object) => [...resourcePickerKeys.all, 'products', params] as const,
  storeProducts: (storeId: string, params: object) =>
    [...resourcePickerKeys.all, 'stores', storeId, 'products', params] as const,
  storeVariants: (storeId: string, storeProductId: string) =>
    [...resourcePickerKeys.all, 'stores', storeId, 'variants', storeProductId] as const,
  collections: (storeId: string, params: object) =>
    [...resourcePickerKeys.all, 'stores', storeId, 'collections', params] as const,
};
